import React, { useEffect } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import { Grid, Paper } from "@mui/material";
import Layout from "../../Layout";
import { ApplicationState } from "../../../store";
import { fetchRequest as fetchCard } from "../../../store/card/actions";
import Alert from "@mui/lab/Alert";
import { Data, CardState } from "../../../store/card/types";
import pageStyles from "../../pageStyles";
import CardEditForm from "./CardEditForm";
import useSession from "../../../effects/useSession";
import PageHeading from "../../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

interface SaveErrorProps {
  children: React.ReactNode;
}

const SaveError: React.FC<SaveErrorProps> = (props) => (
  <Alert severity="error">{props.children}</Alert>
);

export default function CardEdit(): React.ReactElement {
  const dispatch = useDispatch();
  const classes = pageStyles();

  const { id } = useParams<{ id: string }>();
  const mode = id ? UPDATE : CREATE;

  const session = useSession();
  const [showError, setShowError] = React.useState("");
  // let setFieldValueFunc: {
  //   (arg0: string, arg1: any): void;
  //   (field: string, value: any, shouldValidate?: boolean | undefined): void;
  // } | null = null;

  useEffect(() => {
    !isNil(id) && dispatch(fetchCard(id));
  }, []);

  const cardState = useSelector((state: ApplicationState) => state.card);

  const getById = (cardState: CardState, id: string | undefined) => {
    return (
      id &&
      cardState &&
      cardState.data &&
      cardState.data.data?.find((x) => x.id === id)
    );
  };

  const card = getById(cardState, id) as Data;

  const headingText = () => {
    return mode === CREATE ? "New Card Prefix" : "Edit Card Prefix";
  };
  const isCreate = Boolean(mode === CREATE)

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {!isNil(id) && isNil(card) ? (
                  <ProgressIndicator />
                ) : (
                  <CardEditForm
                    card={card}
                    isCreate={isCreate}
                  />
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
